import { auth } from "../firebase/firebaseConfig";
import { STRIPE_BASE } from "./config";

async function authHeaders(extra = {}) {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("Sign in is required.");
  const token = await currentUser.getIdToken();
  return { ...extra, Authorization: `Bearer ${token}` };
}

async function readJson(res) {
  const payload = await res.json().catch(() => ({}));

  if (!res.ok) {
    const error = new Error(
      payload?.error || `Subscription request failed (${res.status})`
    );

    error.status = res.status;
    error.code = payload?.code || null;
    error.action = payload?.action || null;
    error.existingProducts = payload?.existingProducts || [];
    error.requestedProduct = payload?.requestedProduct || null;

    throw error;
  }

  return payload;
}

export async function fetchSubscriptionStatus() {
  const res = await fetch(`${STRIPE_BASE}/subscription/status`, {
    headers: await authHeaders(),
    credentials: "include",
  });
  return readJson(res);
}

export async function openBillingPortal() {
  const res = await fetch(`${STRIPE_BASE}/create-billing-portal`, {
    method: "POST",
    headers: await authHeaders({ "Content-Type": "application/json" }),
    credentials: "include",
    body: JSON.stringify({}),
  });
  return readJson(res);
}

export async function startCheckout(productKey = "pwg", term = "monthly") {
  const res = await fetch(`${STRIPE_BASE}/create-checkout-session`, {
    method: "POST",
    headers: await authHeaders({ "Content-Type": "application/json" }),
    credentials: "include",
    body: JSON.stringify({
      productKey,
      term,
    }),
  });

  return readJson(res);
}
